export default __webpack_public_path__ + "static/media/rec1.c1e4f556.webp";